import { render, staticRenderFns } from "./com-edit-orders.vue?vue&type=template&id=18ef4c85&"
import script from "./com-edit-orders.vue?vue&type=script&lang=js&"
export * from "./com-edit-orders.vue?vue&type=script&lang=js&"
import style0 from "./com-edit-orders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports